export const getVisibleExpenses = (expenses, { text, sortBy, startDate = -8640000000000000, endDate = 8640000000000000 }) => {
    return expenses.filter((expense) => {
        const startDateMatch = startDate <= expense.createdAt;
        const endDateMatch = endDate >= expense.createdAt;
        const textMatch = expense.description.toLowerCase().includes(text.toLowerCase());

        return startDateMatch && endDateMatch && textMatch;
    }).sort((a, b) => {
        if (sortBy === 'date') {
            return a.createdAt > b.createdAt ? -1 : 1;
        } else if (sortBy === 'amount') {
            return a.amount < b.amount ? -1 : 1;
        }
    });
};